/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Entry point for all animation APIs of the animation browser package.
 */
export {BrowserAnimationsModule, NoopAnimationsModule} from './module';

export {ɵBrowserAnimationBuilder,ɵBrowserAnimationFactory,ɵAnimationRenderer,ɵAnimationRendererFactory} from './private_export';



// WEBPACK FOOTER //
// ../../../../../packages/platform-browser/animations/src/animations.ts